/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum ContentPermissionType {
  EDIT = "EDIT",
  VIEW = "VIEW",
}

export enum SitePermissionType {
  ANONYMOUS = "ANONYMOUS",
  APP = "APP",
  EXTERNAL = "EXTERNAL",
  INTERNAL = "INTERNAL",
  JSD = "JSD",
}

//==============================================================
// END Enums and Input Objects
//==============================================================

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: ContentAccessDetailsQuery
// ====================================================

export interface ContentAccessDetailsQuery_contentPermissions_subjectsWithEffectiveContentPermissions_nodes_group {
  id: string | null;
  name: string | null;
  permissionType: SitePermissionType | null;
}

export interface ContentAccessDetailsQuery_contentPermissions_subjectsWithEffectiveContentPermissions_nodes_user_profilePicture {
  width: number | null;
  height: number | null;
  isDefault: boolean | null;
  path: string;
}

export interface ContentAccessDetailsQuery_contentPermissions_subjectsWithEffectiveContentPermissions_nodes_user {
  accountId: string | null;
  displayName: string | null;
  email: string | null;
  permissionType: SitePermissionType | null;
  profilePicture: ContentAccessDetailsQuery_contentPermissions_subjectsWithEffectiveContentPermissions_nodes_user_profilePicture | null;
}

export interface ContentAccessDetailsQuery_contentPermissions_subjectsWithEffectiveContentPermissions_nodes {
  id: string | null;
  permissions: (ContentPermissionType | null)[];
  type: string | null;
  displayName: string | null;
  group: ContentAccessDetailsQuery_contentPermissions_subjectsWithEffectiveContentPermissions_nodes_group | null;
  user: ContentAccessDetailsQuery_contentPermissions_subjectsWithEffectiveContentPermissions_nodes_user | null;
}

export interface ContentAccessDetailsQuery_contentPermissions_subjectsWithEffectiveContentPermissions_pageInfo {
  hasNextPage: boolean | null;
  endCursor: string | null;
}

export interface ContentAccessDetailsQuery_contentPermissions_subjectsWithEffectiveContentPermissions {
  groupCount: number;
  userCount: number;
  nodes: (ContentAccessDetailsQuery_contentPermissions_subjectsWithEffectiveContentPermissions_nodes | null)[] | null;
  pageInfo: ContentAccessDetailsQuery_contentPermissions_subjectsWithEffectiveContentPermissions_pageInfo | null;
}

export interface ContentAccessDetailsQuery_contentPermissions {
  subjectsWithEffectiveContentPermissions: ContentAccessDetailsQuery_contentPermissions_subjectsWithEffectiveContentPermissions;
}

export interface ContentAccessDetailsQuery_singleContent_links {
  webui: string | null;
}

export interface ContentAccessDetailsQuery_singleContent {
  id: string | null;
  title: string | null;
  type: string | null;
  links: ContentAccessDetailsQuery_singleContent_links | null;
}

export interface ContentAccessDetailsQuery {
  contentPermissions: ContentAccessDetailsQuery_contentPermissions | null;
  singleContent: ContentAccessDetailsQuery_singleContent | null;
}

export interface ContentAccessDetailsQueryVariables {
  contentId: string;
  first?: number | null;
  after?: string | null;
  filterText?: string | null;
}
